export const getHoursPassed = (dateFrom: Date, dateTo: Date) => {
  const diffTime = Math.abs(Number(dateTo) - Number(dateFrom));
  const diffHours = Math.floor(diffTime / (1000 * 60 * 60));

  return diffHours;
};
